<template>
  <div class="map-details-container">
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <el-row class="map-content" :gutter="24">
      <el-col :span="12">
        <p>学者合作网络</p>
        <div id="author-map"></div>
      </el-col>
      <el-col :span="12">
        <p>论文引文网络</p>
        <div id="paper-map"></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { getChart } from "@/api/hotKeywordsMap";
export default {
  data() {
    return {
      mapId: 0,
      authorChart: null,
      paperChart: null,
      colorList: [
        "#5470c6",
        "#777ca8",
        "#522e75",
        "#bb1924",
        "#d75404",
        "#7b8937",
        "#efa74a",
        "#328daa",
        "#f07995",
        "#595775",
        "#d7b095",
        "#888c46",
        "#009979",
        "#b58fb5",
        "#9b4980",
        "#0d9aa2",
        "#b1d238",
        "#e99a9a",
        "#4198b9",
        "#ee8b22",
        "#068c49",
        "#f5a1bc",
        "#eb8a44",
        "#4d85bd",
        "#ffbb00",
        "#1e656d",
        "#4cb5f5",
        "#b8335b",
        "#1995ad",
        "#2c7873"
      ],
    };
  },
  mounted() {
    this.mapId = this.$route.query.id || 0;
    this.getChartData();
  },
  methods: {
    getChartData() {
      const params = {
        id: this.mapId
      }
      if (['20', '22', '25', '27', '28'].includes(this.mapId)) {
        params.count = 3000
      }
      getChart({params}).then((res) => {
        const data = res.data.data;
        // const nodes = data.nodes.map((i) => {
        //   return {
        //     name: i.name,
        //     symbolSize: i.symbolSize,
        //     id: i.name,
        //     categories: 7,
        //   };
        // });
        // const mapData = {
        //   nodes: nodes,
        //   links: data.links,
        // };
        // console.log("data", mapData);
        this.initAuthorChart(data[0]);
        this.initPaperChart(data[1]);
      });
    },
    initAuthorChart(data) {
      const color = this.colorList[this.mapId] || "#5470c6";
      this.authorChart = echarts.init(document.getElementById("author-map"));
      console.log("this.authorChart ", this.authorChart);
      const option = {
        tooltip: {},
        // legend: [
        //   {
        //     data: graph.categories.map(function (a) {
        //       return a.name;
        //     }),
        //   },
        // ],
        color: [color],
        series: [
          {
            type: "graph",
            layout: "force",
            animation: false,
            label: {
              position: "right",
              formatter: "{b}",
            },
            draggable: true,
            data: data.nodes.map(function (node) {
              node.id = node.name;
              return node;
            }),
            // categories: webkitDep.categories,
            force: {
              edgeLength: 4,
              repulsion: 20,
              gravity: 0.4,
            },
            edges: data.links,
          },
        ],

        // series: [
        //   {
        //     name: "Les Miserables",
        //     type: "graph",
        //     layout: "force",
        //     data: data.nodes.map(function (node) {
        //       node.id = node.name;
        //       return node;
        //     }),
        //     links: data.links,
        //     // categories: graph.categories,
        //     roam: true,
        //     label: {
        //       show: true,
        //       position: "right",
        //       formatter: "{b}",
        //     },
        //     labelLayout: {
        //       hideOverlap: true,
        //     },
        //     scaleLimit: {
        //       min: 0.4,
        //       max: 2,
        //     },
        //     lineStyle: {
        //       color: "source",
        //       curveness: 0.3,
        //     },
        //   },
        // ],
      };
      this.authorChart.setOption(option);
    },
    initPaperChart(data) {
      this.paperChart = echarts.init(document.getElementById("paper-map"));
      const color = this.colorList[this.mapId] || "#5470c6";
      console.log("this.paperChart ", this.paperChart);
      const option = {
        tooltip: {},
        // legend: [
        //   {
        //     data: graph.categories.map(function (a) {
        //       return a.name;
        //     }),
        //   },
        // ],
        color: [color],
        series: [
          {
            type: "graph",
            layout: "force",
            animation: false,
            label: {
              position: "right",
              formatter: "{b}",
            },
            draggable: true,
            data: data.nodes.map(function (node) {
              node.id = node.name;
              return node;
            }),
            // categories: webkitDep.categories,
            force: {
              edgeLength: 4,
              repulsion: 20,
              gravity: 0.5,
            },
            edges: data.links,
          },
        ],

        // series: [
        //   {
        //     name: "Les Miserables",
        //     type: "graph",
        //     layout: "force",
        //     data: data.nodes.map(function (node) {
        //       node.id = node.name;
        //       return node;
        //     }),
        //     links: data.links,
        //     // categories: graph.categories,
        //     roam: true,
        //     label: {
        //       show: true,
        //       position: "right",
        //       formatter: "{b}",
        //     },
        //     labelLayout: {
        //       hideOverlap: true,
        //     },
        //     scaleLimit: {
        //       min: 0.4,
        //       max: 2,
        //     },
        //     lineStyle: {
        //       color: "source",
        //       curveness: 0.3,
        //     },
        //   },
        // ],
      };
      this.paperChart.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.map-content {
  margin-top: 32px;
  text-align: center;
  p {
    margin-bottom: 12px;
    font-size: 18px;
  }
}
.archive-head {
  width: 100%;
  background-color: #0275d8;
  color: white;
  font-size: 16px;
  height: 50px;
  padding: 10px 15px;
  img {
    width: 100px;
  }
}
#author-map {
  width: 100%;
  height: 600px;
}
#paper-map {
  width: 100%;
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mapDetails/index.vue